// Campus photo for /colleges/brigham-young-university: CC BY 2.0, by Tony Webster, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABrigham_Young_University_Campus_-_BYU_-_Provo_-_Utah_in_Autumn.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/brigham-young-university/; credited under the photo.
const photo = {
    "slug": "brigham-young-university",
    "alt": "The Brigham Young University campus in autumn, with the mountains above Provo, Utah",
    "src": "/colleges/brigham-young-university/campus-1600.webp",
    "srcSmall": "/colleges/brigham-young-university/campus-800.webp",
    "srcMid": "/colleges/brigham-young-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/brigham-young-university/og.jpg",
    "title": "Brigham Young University Campus - BYU - Provo - Utah in Autumn",
    "author": "Tony Webster",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABrigham_Young_University_Campus_-_BYU_-_Provo_-_Utah_in_Autumn.jpg",
    "read": "2026-10-01"
};

export default photo;
